import { SetStateAction } from "react";
import { IUploadExcelFile } from "@ts/common-types";
import { FaCheckCircle } from "react-icons/fa";

interface IUploadedAssetProps {
    setUploadExcelFile: React.Dispatch<SetStateAction<IUploadExcelFile>>;
}

const UploadedAssetComponent = ({
    setUploadExcelFile,
}: IUploadedAssetProps) => {
    return (
        <>
            <div className="uploader text-center">
                <label htmlFor="file-upload" id="file-drag">
                <FaCheckCircle className="text-success mb-3"  style={{
                            fontSize: "3.5rem",
                        }}/>
                    <div className="text-secondary">
                        <h6>File is ready to upload.</h6>
                        <h6>Click on the submit button to apply changes.</h6>
                    </div>
                    <button
                        className="btn btn-sm"
                        style={{ backgroundColor: "#73777B" }}
                        onClick={() => setUploadExcelFile(undefined)}
                    >
                        Upload Again
                    </button>
                </label>
            </div>
        </>
    );
};

export default UploadedAssetComponent;
